import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import UploadImage from "../UploadImage/UploadImage";
import { DeleteApi, base_url, getApi } from "../../Utility/network";
import axios from "axios";
import { AppContext } from "../../ContextApi/AppContext/AppContext";
import deleteicon from "../../assets/componentAssets/deleteicon.svg";
import { consumCertGerText } from "../../Utility/gerLangObject";
import { consumCertEngText } from "../../Utility/engLangObject";
import DownloadIcon from "@mui/icons-material/Download";
import pdfIcon from "../../assets/componentAssets/pdfIcon.svg";
export default function AdditionalNotes({
  openDialog = false,
  setOpenDialog = () => {},
  type,
}) {
  const { state } = React.useContext(AppContext);
  const { language } = state;
  const [open, setOpen] = React.useState(false);
  const [image, setImage] = React.useState(null);
  const [notes, setNotes] = React.useState("");
  const [link, setLink] = React.useState("");
  const [building, setBuilding] = React.useState({
    images: [],
    notes: "",
    link: "",
  });

  React.useEffect(() => {
    setOpen(openDialog);
  }, [openDialog]);

  const handleClose = () => {
    setOpenDialog(false);
  };

  const additionalInfoUrl = React.useMemo(() => {
    return type === 1
      ? `${base_url}/energy_consumption/form/${state.form_id}/additional_information/`
      : `${base_url}/energy_need/${state.needId}/additional_information/`;
  }, [type, state.form_id, state.needId]);

  const patchAdditionalInfo = React.useCallback(
    async (formData, { closeDialog = false } = {}) => {
      const axiosConfig = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      const response = await axios.patch(additionalInfoUrl, formData, axiosConfig);
      setBuilding(response.data.data);
      if (closeDialog) setOpenDialog(false);
    },
    [additionalInfoUrl, setOpenDialog]
  );

  React.useEffect(() => {
    if (!image) return;
    const formData = new FormData();
    formData.append("images", image);
    patchAdditionalInfo(formData)
      .then(() => setImage(null))
      .catch((error) => {
        console.error(error);
      });
  }, [image, patchAdditionalInfo]);

  const getData = React.useCallback(async () => {
    try {
      let urls =
        type === 1
          ? `/energy_consumption/additional_information?energy_consumption=${state.form_id}`
          : `/energy_need/additional_information?energy_need=${state.needId}`;
      const response = await getApi(`${urls}`);
      if (response.data.data && response.data.data.length > 0) {
        setBuilding(response.data.data[0]);
        setNotes(response.data.data[0].notes);
        setLink(response.data.data[0].link);
      }
    } catch (error) {}
  }, [type, state.form_id, state.needId]);

  React.useEffect(() => {
    if (openDialog) {
      getData();
    }
  }, [openDialog, getData]);

  const deleteImage = async (id) => {
    try {
      let urls =
        type === 1
          ? `energy_consumption/additional_images/${id}/`
          : `energy_need/additional_images/${id}/`;
      await DeleteApi(`${urls}`);
      getData();
    } catch (error) {}
  };
  const DownloadImg = async (image) => {
    try {
      const response = await fetch(image, { mode: "cors" });
      if (!response.ok) throw new Error("Failed to fetch image.");

      const blob = await response.blob();

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = image.split("/").pop() || "downloaded-image";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Error downloading image:", error.message);
    }
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            borderRadius: "15px",
          },
          component: "form",
          onSubmit: (event) => {
            event.preventDefault();
            handleClose();
          },
        }}
      >
        <DialogTitle>
          <p
            style={{
              color: "#22A156",
              fontSize: "26px",
              lineHeight: "24px",
              textAlign: "center",
            }}
          >
            {language === "de"
              ? consumCertGerText.additional_document
              : consumCertEngText.additional_document}
          </p>
          <hr style={{ background: "#22A156" }} />
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <div
              style={{
                background: "#AFDB2840",
                padding: "10px",
                borderRadius: "10px",
              }}
            >
              <p
                style={{
                  marginTop: "0px",
                  color: "black",
                  fontWeight: "600",
                  marginBottom: "8px",
                  lineHeight: "24px",
                }}
              >
                {language === "de"
                  ? consumCertGerText.document_additional_text
                  : consumCertEngText.document_additional_text}
              </p>
              <p style={{ lineHeight: "16px", marginTop: "8px" }}>
                {language === "de"
                  ? consumCertGerText.document_secondary_text
                  : consumCertEngText.document_secondary_text}
              </p>
            </div>
            <div>
              <p style={{ color: "black", fontWeight: "600" }}>
                {language === "de"
                  ? consumCertGerText.additional_document
                  : consumCertEngText.additional_document}
              </p>
              <UploadImage
                getImage={setImage}
                imgs={image}
                accept={"image/*,application/pdf,.pdf"}
              />
            </div>
          </DialogContentText>
          <div
            style={{
              marginTop: "15px",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            {building.images.map((item, index) => {
              const fileName = item.image.split("/").pop();
              const isPDF = item.image.toLowerCase().endsWith(".pdf");
              return (
                <div
                  style={{
                    backgroundColor: "rgba(175, 219, 40, 0.15)",
                    display: "flex",
                    padding: "10px",
                    borderRadius: "8px",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <img
                      src={isPDF ? pdfIcon : item.image}
                      style={{ width: "60px" }}
                      alt=""
                    />
                    <p style={{ margin: "5px 0px" }}>{fileName}</p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "5px",
                      alignItems: "center",
                      marginTop: "15px",
                    }}
                  >
                    <DownloadIcon
                      color="success"
                      style={{ cursor: "pointer" }}
                      onClick={() => DownloadImg(item?.image)}
                    />
                    <img
                      src={deleteicon}
                      style={{ cursor: "pointer" }}
                      alt=""
                      onClick={() => deleteImage(item.id)}
                    />
                  </div>
                </div>
              );
            })}
          </div>
          <div>
            <p style={{ color: "black", fontWeight: "600" }}>
              {language === "de"
                ? consumCertGerText.link_head
                : consumCertEngText.link_head}
            </p>
            <p style={{ color: "black" }}>
              {language === "de"
                ? consumCertGerText.link_para
                : consumCertEngText.link_para}
            </p>
            <div>
              <TextField
                style={{ width: "100%" }}
                onChange={(e) => {
                  setLink(e.target.value);
                }}
                value={link}
                name="link"
                placeholder="Link"
                size="small"
              />
            </div>
          </div>
          <div>
            <p style={{ color: "black", fontWeight: "600" }}>
              {language === "de"
                ? consumCertGerText.document_info
                : consumCertEngText.document_info}
            </p>
            <div>
              <TextField
                multiline
                maxRows={5}
                style={{ width: "100%" }}
                onChange={(e) => {
                  setNotes(e.target.value);
                }}
                value={notes}
                name="notes"
                placeholder={language === "de" ? "Notizen" : "Notes"}

              />
            </div>
          </div>

          <div style={{ textAlign: "center", marginTop: "10px" }}>
            <Button
              onClick={() => setOpenDialog(false)}
              style={{ marginRight: "10px" }}
              variant="outlined"
              sx={{
                padding: "12px 25px",
                borderRadius: "10px",
                background: "white",
                // boxShadow: "none",
                // color: "white",
                // "&:disabled": {
                //   background: "gray",
                //   color: "#ccc",
                // },
                marginRight: "10px",
              }}
            >
              {language === "de"
                ? consumCertGerText.cancel
                : consumCertEngText.cancel}
            </Button>
            <Button
              onClick={() => {
                const formData = new FormData();
                if (notes) formData.append("notes", notes);
                if (link) formData.append("link", link);
                patchAdditionalInfo(formData, { closeDialog: true }).catch(
                  (error) => console.error(error)
                );
              }}
              variant="contained"
              sx={{
                padding: "12px 25px",
                background: " linear-gradient(90deg, #22A156 0%, #AFDB28 100%)",
                boxShadow: "none",
                borderRadius: "10px",
                color: "white",
                "&:disabled": {
                  background: "gray",
                  color: "#ccc",
                },
              }}
            >
              {language === "de"
                ? consumCertGerText.submit_details
                : consumCertEngText.submit_details}
              {/* Submit details */}
            </Button>
          </div>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
